// Logo wordmark — modernized typography to match the glass navbar.
// The CREWISOR mark stays the same SVG; only the wordmark beside it
// is restyled (uppercase, tight tracking, stronger weight + gradient)
// so it reads as a brand wordmark rather than a page heading.
export default (theme) => ({
  logoLinkWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    textDecoration: 'none',
    color: theme.palette.primary.main,
    // Tiny rise on hover — subtle but tactile.
    transition: 'transform 200ms ease',
    '&:hover': { transform: 'translateY(-0.5px)' },

    // Wordmark beside the SVG mark. Flat primary colour (the
    // earlier two-tone gradient read as flashy against the rest
    // of the bar — a clean monochromatic wordmark looks more
    // grounded).
    '& .MuiTypography-h6': {
      fontSize: '1.5rem',
      lineHeight: 1,
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: theme.palette.primary.main,
    },
  },
  logo: {
    height: 24,
    width: 24,
    shapeRendering: 'geometricPrecision',
    textRendering: 'geometricPrecision',
    imageRendering: 'optimizeQuality',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    // No right margin: parent now owns spacing via flex `gap`.
  },
});
